"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vars = exports.default = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _Reaction = _interopRequireDefault(require("../../components/Reaction"));
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _pickAndRemoveFromObject = _interopRequireDefault(require("../../utils/pickAndRemoveFromObject"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
var _excluded = ["className", "reactions", "onSelect", "overrides", "showLabels", "showCounts", "size", "userReaction", "wrapperProps"];
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var common = _commonProps.defaultCommonProps;
var vars = exports.vars = (0, _initVars.default)({
  applied: common,
  variables: [{
    key: "rootBackgroundColor",
    canHaveColor: true
  }, {
    key: "size"
  }, {
    key: "invertedSize"
  }]
});
var ReactionSelector = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var className = props.className,
    reactions = props.reactions,
    onSelect = props.onSelect,
    _props$overrides = props.overrides,
    overrides = _props$overrides === void 0 ? {} : _props$overrides,
    _props$showLabels = props.showLabels,
    showLabels = _props$showLabels === void 0 ? true : _props$showLabels,
    _props$showCounts = props.showCounts,
    showCounts = _props$showCounts === void 0 ? true : _props$showCounts,
    _props$size = props.size,
    size = _props$size === void 0 ? "medium" : _props$size,
    _props$userReaction = props.userReaction,
    userReaction = _props$userReaction === void 0 ? null : _props$userReaction,
    wrapperProps = props.wrapperProps,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = (0, _reactJss.useTheme)();
  var classes = useStyles(vars.useVars(_objectSpread(_objectSpread({
    rootBackgroundColor: props.backgroundColor
  }, (0, _pickAndRemoveFromObject.default)(otherProps, common)), {}, {
    size: theme.iconSizes[size],
    invertedSize: "-".concat(theme.iconSizes[size], "px")
  })));
  if (!reactions) {
    return null;
  }
  var getCount = function getCount(number, icon) {
    return userReaction === icon ? number + 1 : number;
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    ref: ref
  }, wrapperProps, {
    className: (0, _classnames.default)(classes.variables, classes.root, overrides.root, wrapperProps === null || wrapperProps === void 0 ? void 0 : wrapperProps.className)
  }), reactions.map(function (_ref, index) {
    var name = _ref.name,
      icon = _ref.icon,
      count = _ref.count;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.reaction,
      key: index
    }, showLabels && name && /*#__PURE__*/_react.default.createElement("div", {
      className: classes.label
    }, name), /*#__PURE__*/_react.default.createElement(_Reaction.default, _extends({
      className: (0, _classnames.default)(classes.icon, classes.total, className),
      icon: icon,
      total: showCounts ? getCount(count, icon) : undefined,
      placement: "bottom",
      size: size
    }, otherProps, {
      onClick: function onClick() {
        return onSelect(icon);
      }
    })));
  }));
});
var styles = function styles(theme) {
  return {
    variables: vars.styles,
    root: {
      backgroundColor: vars.get("rootBackgroundColor", theme.colors.baseContrast030),
      padding: [theme.spacing.base, theme.spacing.base / 2, 0],
      borderRadius: 16,
      boxShadow: "0 0 0 1px rgba(0, 0, 0, .05), 0 1px 2px rgba(0, 0, 0, .15)",
      display: "flex"
    },
    reaction: {
      boxSizing: "content-box",
      width: vars.get("size"),
      padding: theme.spacing.base / 2,
      position: "relative",
      textAlign: "center",
      "&:hover": {
        "& > $label": {
          // eslint-disable-next-line @atg/css-rtl-support
          transform: "translateX(-50%) translateY(-10px)",
          opacity: "1"
        },
        "& > $icon": {
          transform: "scale(1.3)"
        }
      }
    },
    label: {
      borderRadius: "14px",
      fontSize: "11px",
      padding: "4px 7px 3px",
      top: vars.get("invertedSize"),
      background: "rgba(0,0,0,.8)",
      color: "#fff",
      position: "absolute",
      fontWeight: "bold",
      textTransform: "capitalize",
      // eslint-disable-next-line @atg/css-rtl-support
      left: "50%",
      // eslint-disable-next-line @atg/css-rtl-support
      transform: "translateX(-50%)",
      transition: "200ms transform cubic-bezier(0.23, 1, 0.32, 1)",
      opacity: "0",
      whiteSpace: "nowrap"
    },
    icon: {
      cursor: "pointer",
      transition: "200ms transform cubic-bezier(0.23, 1, 0.32, 1)",
      "& svg": {
        fill: theme.colors.baseContrast060
      }
    },
    total: {
      fontSize: "11px",
      cursor: "default",
      color: theme.colors.baseContrast090
    }
  };
};
var useStyles = (0, _createUseStyles.default)(styles, {
  name: "ReactionSelector"
});
ReactionSelector.displayName = "ReactionSelector";
var Storybook = exports.Storybook = ReactionSelector;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/action-reactionselector--docs
 */
var exportedComponent = (0, _defaultProps.default)(ReactionSelector);
exportedComponent.displayName = "ReactionSelector";
var _default = exports.default = exportedComponent;